<div class="logs-container">
  <div class="header-section">
    <div class="page-header">
      <div class="header-left">
        <h3 class="title">Logs</h3>
        <p class="subtitle">
          Manage and analyze system errors and application logs.
        </p>
      </div>
    </div>
  </div>

  <div class="filters-section d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
    <div class="d-flex align-items-center gap-3">
      <app-search-box tooltipText="Search By msg, application, sender, originalUrl, methodType, and userId"
      (search)="onSearch($event)"></app-search-box>
      <p-select [options]="logLevels" [(ngModel)]="selectedLogLevel" optionLabel="label" optionValue="value"
        [showClear]="true" class="log-level-dropdown" placeholder="Select Log Level" (onChange)="loadData()">
      </p-select>

      <div class="date-filter icon-only-datepicker">
        <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" dateFormat="dd-mm-yy" [showClear]="true"
          (onSelect)="onDateFilter()" (onClear)="loadData()" [showIcon]="true" placeholder="Select date range">
        </p-datepicker>
      </div>

      @if (hasSelection()) {
        <button class="btn btn-icon btn-delete-bulk" (click)="deleteSelectedLogs()"
          title="Delete Selected">
          <i class="pi pi-trash" style="font-size: 1.25rem;"></i>
        </button>
      }
    </div>
    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
        <button type="button" class="btn btn-icon p-1 header-icon-action-btn" (click)="loadData()" title="Refresh">
          <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
        </button>
        <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn"
          (click)="toggleIncludeDeleted()">
          <i class="pi pi-asterisk" style="font-size: 1.25rem;"
          [style.color]="includeDeleted() ? '#ec4899' : '#6b7280'"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="logger-table">
      <thead>
        <tr>
          <th class="checkbox-col" width="32">
            <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" />
          </th>
          <th style="width: 14%;" class="sortable" (click)="onSort('LevelName')">Level <span class="sort-indicator">{{
          getSortIcon('LevelName') }}</span></th>
          <th style="width: 14%;" class="sortable" (click)="onSort('Timestamp')">Timestamp <span
            class="sort-indicator">{{
          getSortIcon('Timestamp') }}</span></th>
          <th>Message</th>
          <th style="width: 25%;" class="sortable" (click)="onSort('OriginalUrl')">URL <span class="sort-indicator">{{
          getSortIcon('OriginalUrl') }}</span></th>
          <th style="width: 8%;">Method</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        @if (loader()) {
          <tr>
            <td colspan="7" class="centered-cell">
              <app-spinner-loader [width]="35" />
            </td>
          </tr>
        } @else if (logs().length === 0) {
          <tr>
            <td colspan="7" class="no-data-cell">No log found</td>
          </tr>
        } @else {
          @for (log of logs(); track log; let i = $index) {
            <tr [ngClass]="{'deleted-row': !!log.deletedAt}" [class.selected]="log.selected">
              <td class="checkbox-col">
                <input type="checkbox" [(ngModel)]="log.selected" (change)="updateSelectAllState()" />
              </td>
              <td class="log-type">
                <div class="d-flex align-items-center gap-2">
                  <div [class]="'type-chip ' + log.level.toLowerCase()">
                    {{ (log.level.toLowerCase() === 'error' && log.metadata?.status) ? (log.level | titlecase) + ' (' + log.metadata?.status + ')' : (log.level | titlecase) }}
                  </div>
                </div>
              </td>
              <td class="log-timestamp">
                {{ log.timestamp | date: "yyyy-MM-dd HH:mm" }}
              </td>
              <td>
                <p class="notif-msg" [pTooltip]="log.message || 'N/A'" tooltipPosition="top">
                  {{ log.message ? ((log.message | slice:0:50) + (log.message.length > 50 ? '...' : '')) : 'N/A' }}
                </p>
              </td>
              <td class="log-originalUrl">{{ log?.metadata?.originalUrl }}</td>
              <td class="log-method">{{ log?.metadata?.methodType }}</td>
              <td class="text-center">
                <button class="btn btn-view" (click)="viewDetails(log)">
                  View
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    <div class="pagination-section">

      <!-- LEFT -->
      <div class="pagination-info">
        Showing {{ startIndex }} to {{ endIndex }} of {{ totalEntries() }} Entries
      </div>

      <!-- RIGHT -->
      <div class="pagination-right">

        <!-- Page Size -->
        @if (logs().length !== 0) {
          <div class="page-size">
            <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
            <select id="pageSizeSelect" [(ngModel)]="itemsPerPage" (ngModelChange)="onPageSizeChange($event)"
              class="form-select">
              @for (size of pageSizes; track size) {
                <option [value]="size">
                  {{ size }}
                </option>
              }
            </select>
          </div>
        }

        <!-- Buttons -->
        <div class="pagination-buttons">
          <button class="btn btn-outline pagination-btn" [disabled]="currentPage === 1 || logs().length === 0"
            (click)="previousPage()">
            &lt; Prev
          </button>

          <button class="btn btn-outline pagination-btn" [disabled]="currentPage === totalPages || logs().length === 0"
            (click)="nextPage()">
            Next &gt;
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

@if (isView() && selectedLog()) {
  <app-log-details-modal [visible]="isView()" [log]="selectedLog()!"
  (onClose)="closeViewDetails()"></app-log-details-modal>
}